import { Box, Flex } from "@chakra-ui/react";
import SingleLineText from '@components/UI/SingleLineText';
import SingleImage from '@components/Card/SingleImage';
import StructuredTextParser from '@msr/Utility/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';
import MsrSectionTitle from '@msr/components/Headings/MsrSectionTitle';


let MSRInPersonContactUs = ({ section }) => {
    let { sectionContent } = section
    return <Box pt={{ md: "1rem" }} pb={{ md: '3rem' }} bgColor={'#10143B'}>
        <MsrSectionTitle
            titleObj={sectionContent?.[0]}
        />
        <Flex id={'msrInPersonContactUs'} fontFamily={'FedraSansStd-book'} justifyContent={'center'}>
            <StructuredTextParser
                bgTheme="light"
                str={render(sectionContent?.[1].body)} textAlign={'center'} fontSize={{ md: '18px' }} color={"#fff"} />
        </Flex>
        <style>{`
            #msrInPersonContactUs a {
                text-decoration: underline;
                color: #fff;
            }
            `}
        </style>
    </Box>
}

export default MSRInPersonContactUs

